import { render, staticRenderFns } from "./FlexibleDetailTab3.vue?vue&type=template&id=c694387e&scoped=true"
import script from "./FlexibleDetailTab3.vue?vue&type=script&lang=js"
export * from "./FlexibleDetailTab3.vue?vue&type=script&lang=js"
import style0 from "./FlexibleDetailTab3.vue?vue&type=style&index=0&id=c694387e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c694387e",
  null
  
)

export default component.exports